"use client"

import { Suspense } from "react"
import { Canvas } from "@react-three/fiber"
import { OrthographicCamera } from "@react-three/drei"
import ItemModel from "./item-model"
import FluidPlane from "./fluid-plane"
import { MinecraftColorProperties } from "@/types"

interface MinecraftRendererProps {
  id: string
  type: "item" | "fluid"
  colorProps?: MinecraftColorProperties
}

export default function MinecraftRenderer({ id, type, colorProps }: MinecraftRendererProps) {
  const getElement = () => {
    switch(type) {
      case 'item': return <ItemModel itemId={id} colorProps={colorProps} />
      case 'fluid': return <FluidPlane fluidId={id} colorProps={colorProps} />
      default: return null
    }
  }

  return (
    <div className="w-full h-full">
      <Canvas>
        <Suspense fallback={<>Loading...</>}>
          <OrthographicCamera makeDefault zoom={50} position={[50, 50, 50]} />
          <ambientLight intensity={2.5} />
          <directionalLight position={[10, 10, 5]} intensity={1.5} />
          {getElement()}
        </Suspense>
      </Canvas>
    </div>
  )
}
